import "./description_hero.css";